/* js/components/PlyrVideoPlayer.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	append,
	attr,
	binding_callbacks,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal,
	src_url_equal
} from "svelte/internal";

import Plyr from 'plyr';
import { onMount, onDestroy } from 'svelte';
import getVideoId from 'get-video-id';

function create_if_block(ctx) {
	let div;
	let iframe;
	let iframe_src_value;

	return {
		c() {
			div = element("div");
			iframe = element("iframe");
			if (!src_url_equal(iframe.src, iframe_src_value = /*plyrSrc*/ ctx[1])) attr(iframe, "src", iframe_src_value);
			iframe.allowFullscreen = true;
			attr(div, "class", "plyr__video-embed");
			attr(div, "id", "player");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, iframe);
			/*div_binding*/ ctx[3](div);
		},
		p(ctx, dirty) {
			if (dirty & /*plyrSrc*/ 2 && !src_url_equal(iframe.src, iframe_src_value = /*plyrSrc*/ ctx[1])) {
				attr(iframe, "src", iframe_src_value);
			}
		},
		d(detaching) {
			if (detaching) detach(div);
			/*div_binding*/ ctx[3](null);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let if_block = /*plyrSrc*/ ctx[1] && create_if_block(ctx);

	return {
		c() {
			div = element("div");
			if (if_block) if_block.c();
			attr(div, "class", "video-container svelte-6raqw");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if (if_block) if_block.m(div, null);
		},
		p(ctx, [dirty]) {
			if (/*plyrSrc*/ ctx[1]) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(div, null);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);
			if (if_block) if_block.d();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { src } = $$props;
	let videoDomElement;
	let plyr;
	let plyrSrc;

	onMount(() => {
		const options = {
			settings: [],
			hideControls: false,
			fullscreen: { iosNative: true }
		};

		const videoId = getVideoId(src).id;
		const vimeoUrl = `https://player.vimeo.com/video/${videoId}`;

		// plyrSrc = `${vimeoUrl}?loop=false&amp;byline=false&amp;portrait=false&amp;title=false&amp;speed=true&amp;transparent=0&amp;gesture=media`;
		$$invalidate(1, plyrSrc = `${vimeoUrl}`);

		setTimeout(
			() => {
				plyr = new Plyr(videoDomElement, options);
			},
			100
		);
	});

	onDestroy(() => {
		if (plyr) {
			plyr.destroy();
		}
	});

	function div_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			videoDomElement = $$value;
			$$invalidate(0, videoDomElement);
		});
	}

	$$self.$$set = $$props => {
		if ('src' in $$props) $$invalidate(2, src = $$props.src);
	};

	return [videoDomElement, plyrSrc, src, div_binding];
}

class PlyrVideoPlayer extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { src: 2 });
	}
}

export default PlyrVideoPlayer;